import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { TAG_COLOR_CLASSES } from "@/features/tag/constants";
import type { Tag } from "@/features/tag/types";

interface CustomerTagBadgeProps {
  tag: Tag;
  className?: string;
}

/** Renders a tag as a soft-tone badge using the tag's palette colour. */
export function CustomerTagBadge({ tag, className }: CustomerTagBadgeProps) {
  return (
    <Badge className={cn(TAG_COLOR_CLASSES[tag.color], className)}>
      {tag.name}
    </Badge>
  );
}
